import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { ActionState, BaseComponentConfig, ComponentConfig, MenuTitleOptions, UbsComponentStoreService, UpdateComponentStoreService, ViewContainersService, getColumnFieldTitles, getFields, getIdFieldName, getTarget } from '@urbannex/view-containers';
import { ORDR_FORMS } from '../forms';

@Component({
  selector: 'ubs-postal-address',
  templateUrl: './postal-address.component.html',
  styleUrls: ['./postal-address.component.scss']
})
export class PostalAddressComponent extends BaseComponentConfig implements OnInit{
  @Input() orderId:string;

  options:ComponentConfig = {
    name: '',
    title: '',
    standAlone: true,
    defaultParameters: [],
    defaultAction: ActionState.LIST,
    idFieldName: '',
    findForm: new OfbizForm,
    addForm: new OfbizForm,
    listForm: new OfbizList({
      listType: "grid",
      listFormName: "OrderPostalAddressMaps",
      listFormLocation: "component://kwikstore/widget/OrderViewForms.xml",
      columnFields: getFields("OrderPostalAddressMaps", ORDR_FORMS),
      columnFieldTitles: getColumnFieldTitles("OrderPostalAddressMaps", ORDR_FORMS),
      idFieldName: getIdFieldName("OrderPostalAddressMaps", ORDR_FORMS),
      target: getTarget("OrderPostalAddressMaps", ORDR_FORMS),
      viewIndex: 0,
      findParameters: [],
      appContext: "orders",
      remoteFormData: {
        formData: {
          formName: "OrderPostalAddressMaps",
          formLocation: "component://kwikstore/widget/OrderViewForms.xml",
          listType: "grid",
        }
      },
      emptyListMessage: "No Postal Address Found"
    }),
    addForms: [],
    listForms: [],
    actions: [],
    settings: [],
    summaryView: [],
    lookUpEndPoint: '',
    searchResults: undefined,
    breadCrumbData: undefined,
    childComponent: new ComponentConfig,
    customContainerItems: [],
    lookups: [],
    relations: [],
    appContext: '',
    outGoingLinks: [],
    tasks: [],
    menuAndTitleOptions: undefined,
    getMenuAndTitleOptions: function (): MenuTitleOptions {
      throw new Error('Function not implemented.');
    },
    masterDetails: [],
    selectedMasterDetails: undefined,
    selectedRelation: undefined,
    selectedTask: undefined
  }

  componentConfig:ComponentConfig;

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService,
    private componentStore:UbsComponentStoreService) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    }

  ngOnInit(): void {
    this.options.listForm.findParameters.push({"orderId":this.orderId})
    this.componentConfig = new ComponentConfig(this.options);
    this.componentStore.updateComponentConfig(this.componentConfig);
    console.log(this.componentConfig);
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
  }

}
